var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login-wrapper border border-light shadow"
  }, [_c("form", {
    staticClass: "form-signin",
    on: {
      submit: function ($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_c("h2", {
    staticClass: "form-signin-heading text-center mb-4"
  }, [_vm._v("Connexion")]), _vm._v(" "), _c("div", {
    staticClass: "form-group"
  }, [_c("label", {
    staticClass: "sr-only",
    attrs: {
      for: "userName"
    }
  }, [_vm._v("Adresse email")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.login,
      expression: "form.login"
    }],
    staticClass: "form-control",
    attrs: {
      id: "userName",
      type: "text",
      placeholder: "Nom d'utilisateur",
      "aria-label": "Nom d'utilisateur",
      required: "",
      autofocus: ""
    },
    domProps: {
      value: _vm.form.login
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "login", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "form-group"
  }, [_c("label", {
    staticClass: "sr-only",
    attrs: {
      for: "inputPassword"
    }
  }, [_vm._v("Mot de passe")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      type: "password",
      id: "inputPassword",
      placeholder: "Mot de passe",
      "aria-label": "Mot de passe",
      required: ""
    },
    domProps: {
      value: _vm.form.password
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  })]), _vm._v(" "), _vm.error ? _c("div", {
    staticClass: "text-danger mb-3"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c("button", {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      type: "submit",
      disabled: !_vm.form.login || !_vm.form.password || _vm.loading
    }
  }, [_vm.loading ? _c("span", {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      role: "status",
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.loading ? _c("span", [_vm._v("Se connecter")]) : _vm._e()])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };